import { Injectable, Injector } from "@angular/core";
import { ProductService } from './ProductService';

@Injectable()
export class FacadeService {

    constructor(private injector: Injector){}

    private _productService: ProductService;
    public get productService() : ProductService {
        if(!this._productService){
            this._productService = this.injector.get(ProductService);
        }
        return this._productService;
    }
}